

<lib-request-details-header
  [requestDetailsResponse]="requestDetailsResponse()"
  [showRequestId]="true"
  [showTrigger]="false"
  [showCategory]="true"
  [showDescription]="true"
  [showStatus]="true"
  [showCollaboratorsSection]="false" />

<lib-horizontal-tree
  [levels]="levels()"
  [nodesPerLevel]="nodesPerLevel()"
  [isLoadingAtLevel]="isLoadingPerLevel()"
  [canLoadMoreAtLevel]="canLoadMoreAtLevel.bind(this)"
  [isNoneSelectedAtLevel]="isNoneSelected()"
  [showNodeTitle]="false"
  [translations]="{ loadMoreButtonLabel: 'Load More' }"
  (selectedCard)="onCardClick($event)"
  (loadMoreAtLevel)="onLoadMoreAtLevel($event)" />

<!-- for hover effect of node details -->
<ng-template #detailsTemplate let-node>
  <div class="flex flex-col gap-sm">
    <!-- name + state badge -->
    <div class="flex items-start justify-between gap-sm">
      @if (node.details?.['name']) {
        <div
          class="text-neutral-900 text-sm font-semibold"
          libTrimTooltip
          placement="top"
          [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top tree-card-title-tooltip'"
          [trimLength]="48"
          [fullText]="node.details?.['name']"></div>
      }

      <!-- badge component and there is pipe for state -->

      @if (node.details?.['state']) {
        <lib-badge
          [label]="node.details?.['state']?.label"
          [badgeClass]="
            'py-xs px-md border-none text-sm font-medium whitespace-nowrap shrink-0 ' +
            (node.details?.['state']?.value | stepStatus)
          " />
      }
    </div>

    <div class="flex flex-col gap-xs">
      <!-- request id -->
      @if (node.details?.['requestId']) {
        <div class="text-primary-700 text-xs font-medium">
          {{ node.details?.['requestId'] }}
        </div>
      }

      <!-- category -->
      @if (node.details?.['category']) {
        <div class="text-neutral-500 text-xs">
          {{ node.details?.['category'] }}
        </div>
      }

      <!-- current position -->
      @if (node.details?.['currentPositionName']) {
        <div
          class="text-neutral-700 text-xs font-medium border-t border-neutral-200 pt-sm mt-xs">
          {{ node.details?.['currentPositionName'] }}
        </div>
      }

      <!-- due date -->
      @if (node.details?.['dueDate']) {
        <div class="text-neutral-500 text-xs">
          {{ node.details?.['dueDate'] | date: 'mediumDate' }}
        </div>
      }

      <!-- current assignees -->
      @if (node.details?.['currentAssignees']?.length) {
        <div
          class="flex flex-col gap-xs border-t border-neutral-200 pt-sm mt-xs">
          @for (
            assignee of node.details?.['currentAssignees'];
            track assignee.id
          ) {
            <div class="flex items-center gap-xs">
              <lib-avatar
                [img]="assignee.data?.image?.url ?? ''"
                [fullName]="assignee.data?.name ?? ''"
                [borderRadius]="'rounded-full'"
                [size]="''"
                [imgDimensions]="{ width: 24, height: 24 }"
                [placeholderTextClass]="'text-xs font-medium'" />
              <span class="text-neutral-700 text-xs truncate">{{
                assignee.data?.name
              }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
